import React from 'react';
import IndividualCharacteristics from "./charLayout_asdaSpeech26";

export const renderer = (tBallot, allPoints, ballot, locked, content, promptStatuss, rEvent) => {
    const {competitorId} = tBallot.state; 
    var teams = [];
    if (ballot) {

        for(let i=0;i<ballot.competitors.length;i+=2) {
            var team = ballot.competitors[i];
            team.partner = ballot.competitors[i+1]
            team.teamdisplayname = team.displayname + " / " + team.partner.displayname;
            teams.push(team);
        }
    } else return <p>No Ballot Content</p>;
    return (<>
        <div className="row">
            <div className="col-12">
                {ballot && teams.filter(x => {
                            var doesMatch = true;
                            if (competitorId) doesMatch = (x.userId === competitorId || x.partner.userId === competitorId);
                            return (doesMatch && x.role === tBallot.bConfig.roles[0][1])
                        }).map((competitor, index) => {
                    return (
                        <IndividualCharacteristics key={index} tBallot={tBallot} updateContents={tBallot.onUpdateContents}
                            teamdisplayname={competitor.teamdisplayname}
                            competitor={competitor}
                            partner={competitor.partner}
                            content={competitor.content}
                            rankCount={teams.length}
                            allPoints={allPoints}
                            readOnly={locked}
                            options={tBallot.bConfig.characteristics}
                            promptStatus={promptStatuss ? promptStatuss.find(x=>x.userId === competitor.userId): null}
                            rEvent={rEvent}
                            isSubmitted={ballot.isSubmitted}
                        />
                    )
                })
                }
            </div>
        </div>

    </>)
}
